import {useParams} from "react-router-dom";
import React from "react";
import StartActivity from "./StartActivity";
import {decode} from "../../Services/ObfuscatorService";

function GetIdsStartActivity () {
    let {activity, user} = useParams()

    return (
        <StartActivity act={decode(activity)} user={decode(user)}/>
    )
}

export default GetIdsStartActivity;
